import { tracked } from '@glimmer/tracking';
import BaseController from 'uplisting-frontend/pods/base/controller';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export default class SidebarBookingRequestsMessagesController extends BaseController {
  queryParams = [
    {
      replyId: 'reply',
    },
  ];

  @tracked replyId?: string;

  @tracked bookingRequest!: ModelRegistry['booking-request'];
  @tracked reply?: ModelRegistry['contextual-reply'];
  @tracked messagingChannels!: ModelRegistry['messaging-channel'][];
}
